import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { HeadLine } from '../../layouts/headers/HeadLine';
import { refill } from './galleryScript';
import GalleryVisualizer from './GalleryVisualizer';
import './Style.css';

export const GalleryMainPage = () => {

    const { hotelImageInfo } = useSelector((store: any) => (store.app));

    const current = useSelector((store: any) => (store.current));

    const [stackImages, setStackImages] = useState([]);

    const [currentimg, setCurrentimg] = useState(null);
    const [initial, setInitial] = useState(0);

    useEffect(() => {

        async function execScript() {
            const result: any = await refill([], [], null, hotelImageInfo);
            if (result[0] !== undefined) {
                setStackImages(result);
            }
        }

        execScript();

    }, [hotelImageInfo]);

    const selectImage = (e) => {
        setCurrentimg(e);
        setInitial(hotelImageInfo.findIndex(elem => elem.id === e.id));
    }

    return (
        <>
            <div className='w-full fixed z-50 head-hi-sm flex flex-col justify-center'>
                <HeadLine title={current?.nameEs || 'Galeria'} backurl='/' />
            </div>


            <div className='gallery-container'>

                {/* version dinamica */}
                <div className="grid-gallery">
                    {
                        stackImages.map((grid, index) => {

                            return (
                                <div style={{ display: 'grid', gridArea: `${index + 1} / 1 / auto / auto` }} key={"gridarea_" + (index + 1)}>
                                    {
                                        grid.length === 1 ? (

                                            <div className="size_one" style={{ gridArea: `1 / 1 / auto / auto` }}>
                                                <div style={{ paddingTop: `${grid[0].ratio > 0.9 ? (grid[0].ratio > 1.9 ? '40%' : '67%') : '133%'}` }} className="alt-0">
                                                    <img className="grid-gallery__image" src={grid[0].imageUrl} alt="Gallery item" onClick={() => { selectImage(grid[0]) }} />
                                                </div>
                                            </div>
                                        ) : (
                                            grid.length === 2 ? (
                                                <div className='two_items'>
                                                    {
                                                        grid.map((item, index2) => {
                                                            return (


                                                                <div className="size_one" style={{ gridArea: `1 / ${index2 + 1} / auto / auto` }} key={'subitema_' + (index2 + 1)}>
                                                                    <div style={{ paddingTop: (item.ratio <= 0.9 ? '133%' : '67%') }} className="alt-0">
                                                                        <img className="grid-gallery__image" src={item.imageUrl} alt="Gallery item" onClick={() => { selectImage(item) }} />
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>

                                            ) : (<div className='three_items'>
                                                {
                                                    grid.map((item, index3) => {
                                                        return (
                                                            <div className="size_one"
                                                                style={{ gridArea: `${index3 === 0 ? '1' : index3} / ${index3 === 0 ? '1' : '2'} / ${(item.ratio <= 0.9 ? 'span 2' : 'auto')} / auto` }}
                                                                key={'itemtres_' + (index3 + 1)}>
                                                                <div style={{ paddingTop: (item.ratio <= 0.9 ? '133%' : '67%') }} className="alt-0">
                                                                    <img className="grid-gallery__image" src={item.imageUrl} alt="Gallery item" onClick={() => { selectImage(item) }} />
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>)
                                        )

                                    }
                                </div>
                            )
                        })
                    }
                </div>

            </div>

            {
                currentimg && (<GalleryVisualizer gallery={hotelImageInfo} onclose={() => { setCurrentimg(null) }} init={initial} />)
            }

        </>
    );
};

